import { render, staticRenderFns } from "./OsDetails.vue?vue&type=template&id=8b11ee7e&scoped=true&"
import script from "./OsDetails.vue?vue&type=script&lang=js&"
export * from "./OsDetails.vue?vue&type=script&lang=js&"
import style0 from "./OsDetails.vue?vue&type=style&index=0&id=8b11ee7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b11ee7e",
  null
  
)

export default component.exports